import { Box, Stack } from '@mui/material';
import {
  useOffersPerformanceDataQuery,
  useOffersPerformanceSummaryQuery,
} from 'api/reports-service/reports-service';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import {
  LoyaltyPerformanceParamsDiff,
  OfferPerformanceParams,
} from 'api/reports-service/reports-service.types';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import LoyaltyOfferPerformanceAPIDetailsDrawer from 'components/drawers/loyalty-offer-performance-api-details-drawer/loyalty-offer-performance-api-details-drawer.component';
import LoyaltyPerformanceHeader from 'components/loyalty-performance-header/loyalty-performance-header.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import { useTranslation } from 'react-i18next';
import { useLoyaltyOfferPerformanceSearchParams } from '../loyalty-performance-report.hooks';
import LoyaltyOfferPerformanceSummaryCards from './loyalty-offer-performance-summary-cards/loyalty-offer-performance-summary-cards-summary-cards.component';
import PerformanceDataGrid from '../performance-data-grid/performance-data-grid.component';
import { useGetPerformanceSearchResults } from '../performance-data-grid/performance-data-grid.hooks';

const filteredSearchParams: LoyaltyPerformanceParamsDiff<OfferPerformanceParams> =
  ['granularity', 'datatype', 'offerdatatype'];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(
    useLoyaltyOfferPerformanceSearchParams(),
  );
  return (
    <SearchParamsProvider value={searchParams}>
      <LoyaltyOfferPerformance />
    </SearchParamsProvider>
  );
};

const LoyaltyOfferPerformance = () => {
  const { t } = useTranslation();
  const offersPerformanceSummaryQuery = useSearchQuery(
    useOffersPerformanceSummaryQuery,
    { filteredSearchParams },
  );

  const { getSearchResults } = useGetPerformanceSearchResults();

  const offersPerformanceDataQuery = useSearchQuery(
    useOffersPerformanceDataQuery,
    {
      filteredSearchParams,
      getSearchResults: data =>
        getSearchResults(data?.offers, data?.total, 'offerId'),
    },
  );
  const { open, close, isOpen } = useDrawer();

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            offersPerformanceSummaryQuery,
            offersPerformanceDataQuery,
          },
        }}
      >
        <SearchToolbar />
        <Stack>
          <LoyaltyPerformanceHeader open={open} />
        </Stack>
        <Stack spacing={2}>
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              lg: 'repeat(5, 1fr)',
            }}
            gap={2}
          >
            <LoyaltyOfferPerformanceSummaryCards />
          </Box>
        </Stack>
        <PerformanceDataGrid
          displayInfoHeaderName={t(
            'page.loyaltyPerformanceReport.tabs.loyaltyOfferPerformance.grid.offerName.title',
          )}
          queryName="offersPerformanceDataQuery"
          data-testid="LoyaltyOfferPerformance.DataGrid"
          isOffer
        />
        <LoyaltyOfferPerformanceAPIDetailsDrawer
          isOpen={isOpen}
          close={close}
        />
      </MultipleSearchQueryProvider>
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
